export default "__VITE_ASSET__bd3b8cbd__"